/* file description */
import React, { useEffect, useMemo } from 'react';
import { SPField, FormFrom, FormMode } from '@/components/SPForm';
import { Form, Row, Table, Input, Button, Space } from 'antd';
import _ from 'lodash';

export default function ({
  columns,
  tableBaseMode,
  optionColumns,
  form,
  showTableIndex,
  onChange,
  value,
  rowKey,
  dataKey,
  current = 1,
  pageSize = 10,
}) {
  let tabeleColumns = [...columns];
  const isEdit = tableBaseMode === 'add' || tableBaseMode === 'edit';
  // 编辑情况下，渲染表单控件
  tabeleColumns = tabeleColumns.map((x) => ({
    title: (isEdit && x.isRequired) ? <span><span style={{ color: '#ff4d4f' }}>* </span> {x.title}</span> : <span>{x.title}</span>,
    sorter: isEdit ? false : x.sorter,
    dataIndex: x.dataIndex,
    // shouldCellUpdate: (record, prevRecord) => {
    //   if (record?.[x.dataIndex] !== prevRecord?.[x.dataIndex]) {
    //     return true;
    //   }
    //   return false;
    // },
    width: x.width,
    render: (text: any, record: any, index: number, rowIndex: number) => {
      const rowConfig = x.getRowConfig?.(record, rowIndex) || {};
      if (rowConfig.visible === false) {
        return null;
      }
      let disabled = x.isDisabled;
      if (_.isBoolean(rowConfig.disabled)) {
        disabled = rowConfig.disabled;
      }
      return (
        <SPField
          from={FormFrom.Table}
          name={[dataKey, rowIndex, x.dataIndex]}
          render={isEdit ? x.renderFormItem : x.render}
          form={form}
          valueType={x.valueType}
          formItemProps={x.formItemProps}
          fieldProps={x.fieldProps}
          renderConfig={{
            setRowsData: (data) => {
              onChange({ [dataKey]: data });
            },
          }}
          style={{ marginBottom: 0 }}
          request={x.request}
          requestParams={x.params}
          disabled={disabled}
          required={rowConfig.required}
          rowIndex={rowIndex}
          formValue={{ [dataKey]: value }}
          mode={isEdit ? FormMode.Edit : FormMode.Read}
        />
      );
    },
  }));

  if (optionColumns) {
    tabeleColumns.push(optionColumns);
  }

  if (showTableIndex) {
    tabeleColumns.unshift({
      title: '序号',
      dataIndex: 'index',
      width: 60,
      render: (text: any, record: any, index: number) => index + 1,
    });
  }

  // 将扩展tableColrender，添加第四个参数，真实行所在的index
  tabeleColumns = tabeleColumns.map((col) => {
    const render = (text, record, index) => {
      const rowIndex = value.findIndex((row: any) => row._id === record._id);
      return col && col.render(text, record, index, rowIndex);
    };
    return {
      ...col,
      render: col.render ? render : undefined,
    };
  });

  return tabeleColumns;
}
